import type React from 'react';

interface RefreshOutlineProps {
  size?: number;
  fill?: string;
  className?: string;
}

const RefreshOutline: React.FC<RefreshOutlineProps> = ({
  size = 24,
  fill = '#000000',
  className = ''
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M6.22766 1.27969C6.48733 1.02002 6.90858 1.02008 7.16828 1.27969L9.20471 3.31612C9.3294 3.44081 9.39951 3.61009 9.39953 3.78643C9.39953 3.9628 9.32942 4.13203 9.20471 4.25674L7.16828 6.29317C6.90858 6.55287 6.48736 6.55287 6.22766 6.29317C5.96813 6.03346 5.96802 5.61219 6.22766 5.35254L7.22297 4.35723C7.07164 4.35289 6.89754 4.34971 6.69797 4.34971C6.02399 4.34975 5.36481 4.54948 4.80442 4.92393C4.24405 5.2984 3.80726 5.83114 3.54934 6.45381C3.2915 7.07646 3.2244 7.76159 3.35588 8.42256C3.48738 9.08364 3.81169 9.69116 4.2883 10.1678C4.76491 10.6443 5.37248 10.9687 6.03352 11.1002C6.69454 11.2316 7.3796 11.164 8.00227 10.9061C8.62499 10.6481 9.15768 10.2114 9.53215 9.65098C9.90652 9.09059 10.1064 8.43137 10.1064 7.75743C10.1065 7.39029 10.4043 7.09297 10.7715 7.09297C11.1385 7.09316 11.4358 7.3904 11.436 7.75743C11.436 8.69452 11.1581 9.61078 10.6375 10.3899C10.1169 11.169 9.37722 11.7765 8.51154 12.1352C7.64578 12.4938 6.69284 12.5873 5.77375 12.4045C4.8547 12.2217 4.01028 11.7703 3.34768 11.1077C2.68523 10.4452 2.23372 9.60122 2.0509 8.68233C1.86808 7.76324 1.96231 6.8103 2.32092 5.94454C2.67953 5.0788 3.28699 4.33848 4.06613 3.81788C4.84517 3.29744 5.76108 3.01947 6.69797 3.01944C6.81537 3.01944 6.92609 3.02061 7.0302 3.02217L6.22766 2.22032C5.96807 1.96064 5.96807 1.53937 6.22766 1.27969Z"
        fill={fill}
      />
    </svg>
  );
};

export default RefreshOutline;
